module.exports = __webpack_public_path__ + "static/media/caudalrojop75.8f74e058.gif";